export default "__VITE_ASSET__I6fkoQu8__"